import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import { initSagas } from "./initSagas";

export default function configureStore(initialState) {
  //add support for Redux dev tools
  const composeEnhanceres =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhanceres(
      applyMiddleware(sagaMiddleware, thunk, reduxImmutableStateInvariant())
    )
  );

  initSagas(sagaMiddleware);
  return store;
}
